<template>
  <section class="catalog-description">
    <div class="catalog-description__row">
      <a v-if="product.type" :href="product.detailPage" class="catalog-description__title">{{
        product.type
      }}</a>
      <DefLabels :result="product.labels" />
    </div>
    <a :href="product.detailPage" class="catalog-description__text">{{ product.name }}</a>

    <DefProductStatus :result="product">
      <template #isAvailable>
        <p class="available">{{ messages.inStock }}</p>
      </template>
      <template #onOrder>
        <p class="notAvailable">{{ messages.onOrder }}</p>
      </template>
      <p class="notAvailable">{{ messages.outOfStock }}</p>
    </DefProductStatus>

    <CatalogSKU />
    <div v-if="isAvailable()" class="catalog-description__prices">
      <div v-if="product.price">
        <DefPrice v-if="product.price.printPrice">{{ product.price.printPrice }}</DefPrice>
        <DefPriceOld v-if="product.price.printPriceOld">{{
          product.price.printPriceOld
        }}</DefPriceOld>
      </div>
    </div>
    <div v-if="product?.price?.printPriceEUR" class="catalog-description__prices">
      <DefPriceEN>
        {{ product?.price?.printPriceEUR }}
      </DefPriceEN>
    </div>

    <ProductPairControls />

    <div class="description-buttons">
      <DefBuy v-if="isAvailable()" :result="product" :disabled="product?.isPair && !isPairSelected">
        <template #inBasket>
          <span>{{ messages.inBasket }}</span>
        </template>
        {{ messages.addToBasket }}
      </DefBuy>
      <DefBuyOneClick v-if="isAvailable() && !isElectronicCertificate" />
      <DefFavouriteSecondary :result="product" />
    </div>

    <div class="description-installments">
      <GetToday
        v-if="isAvailable() && stores && stores.length > 0"
        :result="product"
        :messages="messages"
      />
      <ProductCreditButton v-if="service" :service="service" />
    </div>

    <SubscribeToAvailability v-if="!isAvailable()" />
    <OrderAProduct v-if="!isAvailable() && onOrder" :result="product">
      <template #onOrder>
        <span>{{ messages.order }}</span>
      </template>
    </OrderAProduct>
    <CatalogDeliveries :result="store.eShopDelivery" />
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';
import DefProductStatus from '@components/Def/DefProductStatus/DefProductStatus.vue';
import CatalogSKU from '@components/Catalog/CatalogSKU.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPriceEN from '@components/Def/DefPrice/DefPriceEN.vue';
import DefBuy from '@components/Def/DefBuy/DefBuy.vue';
import DefBuyOneClick from '@components/Def/DefBuyOneClick/DefBuyOneClick.vue';
import SubscribeToAvailability from '@components/Product/ProductSubscribe/SubscribeToAvailability.vue';
import OrderAProduct from '@components/Product/OrderAProduct.vue';
import CatalogDeliveries from '@components/Catalog/CatalogDeliveries.vue';
import ProductPairControls from '@components/Product/ProductPair/ProductPairControls.vue';
import GetToday from '@components/Product/GetToday/GetToday.vue';
import ProductCreditButton from '@components/Product/ProductCredit/ProductCreditButton.vue';
import DefFavouriteSecondary from '@components/Def/DefFavourite/DefFavouriteSecondary.vue';

export default {
  name: 'CatalogDescription',
  components: {
    DefFavouriteSecondary,
    ProductCreditButton,
    GetToday,
    ProductPairControls,
    CatalogDeliveries,
    OrderAProduct,
    SubscribeToAvailability,
    DefBuyOneClick,
    DefBuy,
    DefPriceEN,
    DefPriceOld,
    DefPrice,
    CatalogSKU,
    DefProductStatus,
    DefLabels,
  },
  props: ['result'],
  computed: {
    ...mapState({
      store: ({ results }) => results?.storeInformation,
      stores: ({ stores }) => stores?.data?.stores,
      isPairSelected: ({ product }) => product?.data?.isPairSelected,
    }),
    ...mapGetters({
      isAvailable: 'product/isAvailable',
    }),
    product() {
      return this.result.product;
    },
    messages() {
      return this.result.messages;
    },
    onOrder() {
      return this.result?.product?.offer?.onOrder;
    },
    isElectronicCertificate() {
      return this.result?.product?.isElectronicCertificate;
    },
    service() {
      return this.result?.product?.serviceBlocks?.find((el) => el.code === 'kalkulyator');
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-description {
  &__row {
    display: flex;
    margin-bottom: 8px;
  }
  &__title {
    font-weight: 600;
    font-size: rem(24);
    text-transform: uppercase;
    margin-bottom: 0;
    margin-right: 12px;
    line-height: 125%;
  }
  &__text {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    color: var(--color-dark-grey);
    margin-bottom: 24px;
  }
  &__prices {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  :deep(.def-price) {
    font-size: rem(24);
  }
  :deep(.def-price-en) {
    font-size: rem(20);
  }
  :deep(.def-price-old) {
    margin-left: 8px;
    font-size: 20px;
    font-weight: 600;
  }
  :deep(.catalog-sku) {
    margin-bottom: 24px;
  }
  :deep(.def-buy) {
    width: 100%;
  }
  :deep(.def-product-status) {
    margin-bottom: 16px;
  }
  :deep(.subscribe-to-availability) {
    margin-bottom: 24px;
  }
  :deep(.order-a-product) {
    width: 100%;
    margin-bottom: 8px;
  }
}
.description-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.description-installments {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;
}
</style>
